<template>
  <div
    class="pb-4 lg:!grid lg:!grid-cols-3"
    :class="{ 'lg:!-mx-4': width === 'full' }"
  >
    <div
      :class="[
        'col-span-1 auto-rows-min',
        'pb-4 lg:!py-0 lg:!pr-4 min-h-full',
        width === 'full' ? 'w-full' : ''
      ]"
    >
      <slot name="one" />
    </div>
    <div
      :class="[
        'col-span-1 auto-rows-min',
        'border-t border-gray-100 dark:border-gray-800 lg:!border-t-0 lg:!border-l',
        'w-full py-4 lg:!py-0 lg:!px-4 lg:!flex lg:!flex-col min-h-full',
        width === 'auto' ? 'w-96' : '',
      ]"
    >
      <slot name="two" />
    </div>
    <div
      :class="[
        'col-span-1 auto-rows-min',
        'border-t border-gray-100 dark:border-gray-800 lg:!border-t-0 lg:!border-l',
        'w-full pt-4 lg:!py-0 lg:!flex lg:!flex-col lg:!pl-4 min-h-full',
        width === 'auto' ? 'min-w-72' : '',
      ]"
    >
      <slot name="three" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ColThree"
})

defineProps({
  proportion: { type: String, default: '33-33-33' },
  width: { type: String, default: 'full' }
})
</script>
